import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        filePath: '<'
    },
    template: `
        <!-- Loader -->
        <loader-icon
            ng-if="vm.loading"
            width="100px"
            height="100px"
            message="{{ vm.getMessage() }}"
        />

        <!-- HTML Viewer -->
        <courses-authoring-tool-iframe-html-viewer
            ng-if="!vm.loading && vm.viewerType === 'html'"
            file-path="vm.filePath"
        />

        <!-- Microsoft Live Mock -->
        <courses-authoring-tool-iframe-microsoft-viewer
            ng-if="!vm.loading && vm.viewerType === 'mslive'"
            file-path="vm.filePath"
        />
    `
})
export default class {
    constructor (MaterialFileResource, MATERIAL_FILE_STATUS_ENUM, $timeout, $translate) {
        this.MaterialFileResource = MaterialFileResource;
        this.MATERIAL_FILE_STATUS_ENUM = MATERIAL_FILE_STATUS_ENUM;
        this.$timeout = $timeout;
        this.pollCount = 0;
        this.maxPolls = 100;
        this.$translate = $translate;
    }

    $onInit () {
        const match = this.filePath.match(/material-chapter-file\/([a-f0-9]{64})/);
        this.filenameHash = match ? match[1] : null;
        this.loading = true;
        this.viewerType = null;
        this.updateStatus();
    }

    getMessage () {
        return this.$translate.instant('authoringTool.Document is converting');
    }

    updateStatus () {
        this.MaterialFileResource.getStatus({ filenameHash: this.filenameHash }).$promise
            .then((data) => {
                const status = data.status;
                const extension = data.extension;
                const { KEYS } = this.MATERIAL_FILE_STATUS_ENUM;

                if (status === KEYS.CONVERTING) {
                    this.loading = true;

                    if (this.pollCount < this.maxPolls) {
                        this.pollCount++;
                        this.$timeout(() => this.updateStatus(), 2000); // 2 seconds
                    }
                    else {
                        this.loading = false;
                        this.viewerType = 'mslive';
                    }
                }
                else if (status === KEYS.COMPLETED) {
                    this.loading = false;
                    if (extension === 'zip') {
                        this.viewerType = 'html';
                    }
                    else {
                        this.viewerType = 'mslive';
                    }
                }
                else if (status === KEYS.FAILED) {
                    this.loading = false;
                    this.viewerType = 'mslive';
                }
            })
            .catch(() => {
                this.loading = false;
                this.viewerType = 'mslive';
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/iframe/convertedFileViewer/index.js